import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import './GitHubCallback.css';

const ERROR_MESSAGES = {
  not_registered: 'Este e-mail do Google não está cadastrado no sistema. Contate seu administrador.',
  inactive: 'Sua conta está inativa. Contate seu administrador.',
  pending: 'Seu cadastro está aguardando aprovação.',
  rejected: 'Seu cadastro foi rejeitado. Contate seu administrador.',
  no_email: 'Não foi possível obter o e-mail da conta Google.',
  server_error: 'Erro no servidor. Tente novamente.',
  token_error: 'Erro ao gerar acesso. Tente novamente.',
  unknown: 'Erro desconhecido. Tente novamente.'
};

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    const reason = searchParams.get('reason');
    if (reason) {
      setError(ERROR_MESSAGES[reason] || ERROR_MESSAGES.unknown);
      setStatus('error');
      setTimeout(() => navigate('/login'), 4000);
      return;
    }

    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          setError('Token não encontrado');
          setStatus('error');
          return;
        }

        localStorage.setItem('token', token);
        const response = await fetch(getApiUrl('auth/me'), {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData.user);
          setStatus('success');
          setTimeout(() => navigate('/overview'), 2000);
        } else {
          throw new Error('Falha ao obter dados do usuário');
        }
      } catch (err) {
        setError(err.message);
        setStatus('error');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setUser]);

  if (status === 'processing') return (
    <div className="callback-container"><div className="callback-card">
      <div className="loading-spinner"></div>
      <h2>🔄 Processando login...</h2>
      <p>Aguarde enquanto finalizamos seu login com Google</p>
    </div></div>
  );

  if (status === 'success') return (
    <div className="callback-container"><div className="callback-card success">
      <div className="success-icon">✅</div>
      <h2>Login realizado com sucesso!</h2>
      <p>Redirecionando...</p>
    </div></div>
  );

  return (
    <div className="callback-container"><div className="callback-card error">
      <div className="error-icon">❌</div>
      <h2>Erro no login</h2>
      <p>{error}</p>
      <p>Redirecionando para a página de login...</p>
    </div></div>
  );
};

export default GoogleCallback;
